import React from 'react';
import { useSelector } from 'react-redux';
import { usesOperationalOverviewLayout } from '../../utils/overviewProjectType';
import StandardOverview from './Standard/StandardOverview';
import OperationalProjectOverview from './Standard/OperationalProjectOverview';

const Overview = () => {
    const { selectedProject } = useSelector(state => state.projectData);
    const projectType = selectedProject?.project_type;

    if (usesOperationalOverviewLayout(projectType)) {
        return <OperationalProjectOverview />;
    }

    return <StandardOverview />;
};

export default Overview;
